import React from "react";
import { useTheme } from "styled-components";
import * as StyledNav from "../Styled.Nav";

const LogoS = ({ fill }) => {
  const theme = useTheme();
  return (
    <StyledNav.Logo
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 85 82"
      fill={theme.colors.imperialRed}
    >
      <path d="M24.81 43.412h24.118l-3.877 14.47H20.932a11.101 11.101 0 01-10.725-13.977l8.882-33.144A14.517 14.517 0 0133.112 0h3.33L24.81 43.412zm31.873-28.941l-5.17 19.294H37.042L46.089 0h38.589L80.8 14.471H56.683zM48.235 82H0l3.877-14.471h48.236l11.632-43.411A11.102 11.102 0 0174.47 38.095l-8.019 29.928A18.858 18.858 0 0148.235 82z"></path>
    </StyledNav.Logo>
  );
};

export default LogoS;
